import React, { Component } from 'react'
import {connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import SourcingAndSelectionForm from '../form/SourcingAndSelectionForm'
import {
    onChangeAdditionalRequirement
} from '../../actions/RequisitionActions'
import * as Sentry from '@sentry/browser'

Sentry.init({
    dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});



class SourcingAndSelection extends Component {

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }
    
    render() {

        const { classes , onChangeAdditionalRequirement, next, back} = this.props
        const length_of_advertistment = [1, 2, 3, 4]

        return (
            <div className={classes.main}>
                <SourcingAndSelectionForm 
                    onChangeRequirment={onChangeAdditionalRequirement}
                    next={next}
                    back={back}
                    onSubmit={next}
                    lengthOfAdvertistment={length_of_advertistment}
                />
            </div>
        )
    }

}

SourcingAndSelection.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch, props) => ({
    onChangeAdditionalRequirement: (data) => {
        dispatch(
            onChangeAdditionalRequirement(data)
        )
    }
})

const mapStateToProps = state => ({
    requisition_data: state
})


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(requisitionFormStyle)(SourcingAndSelection))